<template>
<div>
  <ConfirmationBar
    :showSavebar="showSavebar"
    @confirm="savePreferenceData"
    @cancel="cancelPreferenceSave"
  />
  <div class="full-page-width relative locations">
    <div class="row">
      <div class="col-xs-4 sticky-100">
        <div class="flex-center m-b-40 h-40">
          <div class="flex-center">
            <Btn
              v-if="nameAndBackOption"
              @click.native="routeIt"
              class="light bordered empty d-inline-block m-r-15 fix-40"
              :icon="{
                name: 'arrowLeftBig',
                size: '20',
              }" />
            <p class="user-name">{{ $t('Profile') }}</p>
          </div>
        </div>
        <UserCard @openPopupEdit="openEditPopup" :isEditable="isEditableProfile" />
      </div>
      <div class="col-xs-8">
        <h2 class="page-title heighted">{{ $t('Printers and labels') }}</h2>
        <div class="m-b-40 card">
          <InputSelect
            class="m-b-40"
            :label="$t('My label printer')"
            v-model="userData.label_printer_id"
            :options="get_label_printers"/>
          <InputSelect
            class="m-b-40"
            :label="$t('My document printer')"
            v-model="userData.document_printer_id"
            :options="get_document_printers"/>
          <InputSelect
            class="m-b-40"
            :label="$t('Label paper size')"
            v-model="userData.label_format"
            :options="get_label_formats"/>
          <InputSelect
            :label="$t('integration_autoprint')"
            v-model="userData.is_api_autoprint"
            :options="[{value: '0', text: $t('no')}, {value: '1', text: $t('yes')}]"/>
        </div>
        <h2 class="m-b-20 page-title">{{ $t('signature') }}</h2>
        <div class="m-b-40 card">
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('signature') }}</p>
              <span style="color: #bdc0c4;">{{ get_stored_user.signature_img_path === '' ? $t('upload_your_signature') : $t('signature_uploaded')}}</span>
            </div>
            <div style="display: flex; justify-content: flex-end;">
              <div v-if="get_stored_user.signature_img_path" @click="removeSignature">
                <Btn
                  class="m-r-20 button red d-inline-block"
                  :icon="{name: 'deleteForever', size: '20'}"
                  :btnText="$t('remove')" />
              </div>
              <div @click="uploadSignature">
                <input
                  accept="image/*"
                  @change="signatureSelected"
                  type="file"
                  ref="signatureUploadInput"
                  style="display:none" />
                <Btn class="brand"
                     :icon="{name: 'cloudUpload', size: '20'}"
                     :btnText="$t('upload_signature')" />
              </div>
            </div>
          </div>
        </div>
        <h2 class="m-b-20 page-title">{{ $t('system') }}</h2>
        <div class="m-b-40 card">
          <div class="m-b-20">
          <InputSelect
            :label="$t('language')"
            v-model="userData.language"
            :options="[{value: 'en', text: 'English'}, {value: 'dk', text: 'Danish'}]"
            :rules="{required: true}" />
            </div>
          <div class="m-b-20">
          <InputSelect
            :label="$t('LBL_DATE_FORMAT')"
            v-model="userData.date_format"
            :options="[{value: 'dd/MM/yyyy', text: 'DD/MM/YYYY'}, {value: 'dd.MM.yyyy', text: 'DD.MM.YYYY'}, {value: 'MM/dd/yyyy', text: 'MM/DD/YYYY'},  {value: 'MM.dd.yyyy', text: 'MM.DD.YYYY'}]"
            :rules="{required: true}" />
            </div>
          <div class="m-b-20">
          <InputSelect
            :label="$t('LBL_TIME_FORMAT')"
            v-model="userData.time_format"
              :options="[{value: 'HH:mm', text: '24H Format (e.g. 15:00)'}, {value: 'hh:mm a', text: '12H Format (e.g. 03:00 AM)'}]"
            :rules="{required: true}" />
            </div>
          <div class="m-b-20">
          <InputSelect
            :label="$t('LBL_TIMEZONE')"
            v-model="userData.timezone"
            :options="timezones"
            :rules="{required: true}" />
            </div>
        </div>
        <h2 class="m-b-20 page-title">{{ $t('Show prices') }}</h2>
        <div class="m-b-40 card">
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('Show prices') }}</p>
              <span style="color: #bdc0c4;">{{ $t('Show prices freight prices') }}</span>
            </div>
            <div>
              <Toggle
                id="show_prices" v-model="userData.should_show_freight_prices"/>
            </div>
          </div>
          <div class="m-b-20">
            <InputSelect
              :label="$t('currency')"
              v-model="userData.currency"
              :options="get_user_available_currencies"
              @change="onCurrencyChange"
              :rules="{required: true}" />
          </div>
          <div class="m-b-20 flex-center toggle-title" v-if="!userData.is_custom_currency">
            <span style="color: #bdc0c4;">{{ $t('default_currency_text')}} openexchangerates.org</span>
          </div>
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('LBL_IS_USER_VAT') }}</p>
              <span style="color: #bdc0c4;">{{ $t('TXT_ADD_VAT_ON_PRICES') }}</span>
            </div>
            <div>
              <Toggle
                id="is_user_vat" v-model="userData.is_user_vat"/>
            </div>
          </div>
          <div class="m-b-40"  v-if="userData.is_user_vat">
            <div>
              <InputSelect
                :label="$t('vat_user_percent')"
                v-model="userData.vat_user_percent"
                :options="percentageOptions"/>
            </div>
          </div>
        </div>
        <h2 class="m-b-20 page-title">{{ $t('Defaults for Booking') }}</h2>
        <div class="m-b-40 card">
          <InputSelect
            class="m-b-40"
            :label="$t('Shipper')"
            v-model="userData.sender_id"
            :options="shippers"/>
          <InputSelect
            class="m-b-40"
            :label="$t('Receiver')"
            v-model="userData.receiver_id"
            :options="receiverLocations"/>
          <CountrySelect
            class="m-b-40"
            :enable-select-none="true"
            :label="$t('receiver_default_country')"
            v-model="userData.receiver_country_id"
            @change="showNotification" />
          <InputSelect
            class="m-b-40"
            :label="$t('goods_type')"
            v-model="userData.goods_type_id"
            :options="get_goods_types"/>
          <InputSelect
            v-if="get_document_packages_available.length > 1"
            class="m-b-40"
            :label="$t('document_packaging')"
            v-model="userData.document_package_id"
            :options="get_document_packages_available"/>
          <InputSelect
            v-if="get_parcel_packages_available.length > 1"
            class="m-b-40"
            :label="$t('parcel_packaging')"
            v-model="userData.parcel_package_id"
            :options="get_parcel_packages_available"/>
          <InputSelect
            v-if="get_pallet_packages_available.length > 1"
            class="m-b-40"
            :label="$t('pallet_packaging')"
            v-model="userData.pallet_package_id"
            :options="get_pallet_packages_available"/>
          <InputSelect
            :label="$t('LBL_AUTOMATIC_PALLET_EXCHANGE')"
            v-model="userData.auto_pallet_exchange"
            class="m-b-40"
            :options="autoPalletExchangeOptions" />
          <InputSelect
            :label="$t('Stackable')"
            v-model="userData.stackable"
            class="m-b-40"
            :options="stackOptions" />
          <InputSelect
            v-if="get_load_packages_available.length > 1"
            class="m-b-40"
            :label="$t('load_packaging')"
            v-model="userData.load_package_id"
            :options="get_load_packages_available"/>
          <InputSelect
            class="m-b-40"
            :label="$t('Return waybill options')"
            v-model="userData.return_waybill_action_type"
            :options="get_return_waybill_action_types"/>
          <InputSelect
            class="m-b-40"
            :label="$t('weight_type')"
            v-model="userData.weight_type"
            :options="unitsWeightSelection" />
          <InputSelect
            class="m-b-40"
            :label="$t('Dimension type')"
            v-model="userData.dimension_type"
            :options="unitsDimensionSelection"/>
          <InputText
            class="m-b-40"
            :label="$t('shipper_reference')"
            v-model="userData.shipper_reference"/>
          <InputText
            class="m-b-40"
            :label="$t('receiver_reference')"
            v-model="userData.receiver_reference"/>
          <InputText
            class="m-b-40"
            :label="$t('Receiver email')"
            v-model="userData.receiver_email"/>
          <InputText
            :label="$t('description')"
            v-model="userData.description"/>
        </div>
        <h2 v-if="get_is_admin" class="m-b-20 page-title">{{ $t('Permissions for Booking') }}</h2>
        <div v-if="get_is_admin" class="m-b-40 card">
          <InputSelect
            class="m-b-40"
            :multiSelect=true
            :preselected="userData.allowed_goods_types"
            :label="$t('Allowed goods type')"
            @change="selectAllowedGoodsType"
            :options="allowedGoodsType" />
          <InputSelect
            class="m-b-40"
            :label="$t('Book permission type')"
            v-model="userData.book_permission_type"
            :options="bookPermissionType"/>
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('LBL_LOCK_RECEIVER') }}</p>
              <span style="color: #bdc0c4;">{{ $t('TXT_LOCK_RECEIVER') }}</span>
            </div>
            <div>
              <Toggle
                id="lock_receiver" v-model="userData.lock_receiver"/>
            </div>
          </div>
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('LBL_LOCK_SENDER') }}</p>
              <span style="color: #bdc0c4;">{{ $t('TXT_LOCK_SENDER') }}</span>
            </div>
            <div>
              <Toggle
                id="lock_sender" v-model="userData.lock_sender"/>
            </div>
          </div>
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('Show temperature') }}</p>
              <span style="color: #bdc0c4;">{{ $t('Show temperature') }}</span>
            </div>
            <div>
              <Toggle
                id="show_has_temperature" v-model="userData.show_has_temperature"/>
            </div>
          </div>
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('Show dangerous goods') }}</p>
              <span style="color: #bdc0c4;">{{ $t('Show dangerous goods') }}</span>
            </div>
            <div>
              <Toggle
                id="show_dangerous_goods" v-model="userData.show_dangerous_goods"/>
            </div>
          </div>
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('Show freight paid by') }}</p>
              <span style="color: #bdc0c4;">{{ $t('Show freight paid by') }}</span>
            </div>
            <div>
              <Toggle
                id="show_freight_paid_by" v-model="userData.show_freight_paid_by"/>
            </div>
          </div>
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('Show incoterms') }}</p>
              <span style="color: #bdc0c4;">{{ $t('Show incoterms') }}</span>
            </div>
            <div>
              <Toggle
                id="show_incoterms" v-model="userData.show_incoterms"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Popup
      v-if="openPopup"
      :popupSmall=true
      :isPopupSubmitDisabled="isPopupSubmitDisabled"
      :showConfirmButton="!deleteUser"
      :showDeleteButton="deleteUser"
      @cancel="togglePopup"
      @deleteAction="deleteUserAction"
      @confirm="saveProfileData">
      <template v-slot:header>
        <h2>{{ $t('Edit profile') }}</h2>
      </template>
      <div>
        <div class="row" v-if="get_is_admin">
          <div class="col-xs-12">
            <div class="flex-center toggle-title">
              <div class="input-select">
                <label>{{ $t('activate_user')}}</label>
                <span>{{ $t('enable_user_to_login') }}</span>
              </div>
              <div>
                <Toggle id="deactivateUser" v-model="form.is_active" />
              </div>
            </div>
          </div>
        </div>
        <div class="separator medium" v-if="get_user.is_admin"></div>
        <div class="row">
          <div class="col-xs-12 m-b-20" v-if="get_user.is_super_admin">
            <InputSelect
            :multiSelect=true
            :label="$t('Accessible accounts')"
            :preselected="form.accessible_subaccounts"
            @change="selectSubaccounts"
            :options="subacountsList"/>
          </div>
          <div class="col-xs-12 m-b-20" v-if="(get_user.is_admin && !get_stored_user.is_super_admin) || get_user.is_system_user">
            <InputSelect
              :multiSelect=true
              :preselected="form.accessible_for_subaccounts"
              :label="$t('accessible_for_accounts')"
              @change="selectAccessibleForSubaccounts"
              :options="getAllowedSubaccounts" />
          </div>
          <InputText
            :disabled=true
            class="col-xs-6 m-b-20"
            label="E-mail"
            v-model="form.email"
            :rules="{required: true, email: true}" />
          <InputText
            class="col-xs-6 m-b-20"
            :label="$t('Title')"
            v-model="form.function" />
          <InputText
            class="col-xs-6 m-b-20"
            :label="$t('name')"
            v-model="form.first_name"
            :rules="{required: true}" />
          <InputText
            class="col-xs-6 m-b-20"
            :label="$t('Surname')"
            v-model="form.last_name"
            :rules="{required: true}" />
          <PhoneSelect class="col-xs-12" key="userPhone" v-model="form.phone" />
        </div>
        <div class="separator medium"></div>
        <div class="row">
          <div class="col-xs-12">
            <div class="flex-center toggle-title">
              <div>
                <p>{{ $t('Reset password') }}</p>
                <span>{{ $t('This will reset password') }}</span>
              </div>
              <div>
                <Btn
                  class="brand"
                  :icon="{name: 'restore',size: '20'}"
                  :btnText="$t('Reset')"
                  @btnClick="resetPassword" />
              </div>
            </div>
          </div>
        </div>
        <div class="separator medium" v-if="get_is_admin && !get_stored_user.is_admin"></div>
        <div class="row" v-if="get_is_admin && !get_stored_user.is_admin">
          <div class="col-xs-12">
            <div class="flex-center toggle-title">
              <div>
                <p>{{ $t('delete_user') }}</p>
                <span>{{ $t('User will be deleted') }}</span>
              </div>
              <div>
                <Toggle color="red" id="deleteUser" v-model="deleteUser" />
              </div>
            </div>
          </div>
        </div>
      </div>
  </Popup>
</div>
</template>

<script>
/* eslint-disable */
import {mapGetters} from 'vuex';
import mixin from '@/mixins/mixins.js';
import Btn from '@/components/elements/buttons';
import ConfirmationBar from '@/components/global/confirmationBar';
import InputText from '@/components/elements/inputs/text.vue';
import Popup from '@/components/global/popup';
import UserCard from '@/components/global/userCard';
import InputSelect from '@/components/elements/inputs/select.vue';
import Toggle from '@/components/elements/inputs/toggle.vue';
import PhoneSelect from '@/components/elements/inputs/phone.vue';
import formValidator from '@/mixins/formValidator';
import CountrySelect from '@/components/elements/inputs/countrySelect.vue';
import {enTimezone, dkTimezone} from '@/data/timezones'
import i18n from "@/i18n";
import PalletExchange from "@/components/elements/inputs/palletExchange.vue";

export default {
  name: 'Preferences',
  mixins: [mixin, formValidator],
  components: {
    PalletExchange,
    ConfirmationBar,
    Btn,
    Popup,
    InputText,
    UserCard,
    InputSelect,
    Toggle,
    PhoneSelect,
    CountrySelect,
  },
  data() {
    return {
      openPopup: false,
      deleteUser: false,
      form: {
        is_admin: '',
        active_subaccount_id: '',
        is_active: '',
        language: '',
        time_format: '',
        date_format: '',
        timezone: '',
        email: '',
        password: '',
        first_name: '',
        last_name: '',
        function: '',
        return_waybill_action_type: '',
        label_printer_id: '',
        label_format: '',
        goods_type_id: '',
        document_package_id: '',
        parcel_package_id: '',
        pallet_package_id: '',
        stackable: '',
        auto_pallet_exchange: '',
        load_package_id: '',
        weight_type: '',
        dimension_type: '',
        should_show_freight_prices: '',
        currency: '',
        is_custom_currency: false,
        phone: {
          number: '',
          country: '',
        },
        accessible_subaccounts: [],
        accessible_for_subaccounts: []
      },
      showSavebar: false,
      loadUser: false,
      loadPreferences: false,
      userId: '',
      stackOptions: [
        {text: this.$t('Stacked'), value: 'stacked'},
        {text: this.$t('Stackable'), value: 'stackable'},
        {text: this.$t('Non-Stackable'), value: 'non_stackable'},
      ],
      autoPalletExchangeOptions: [
        {text: this.$t('yes'), value: 1},
        {text: this.$t('no'), value: 0},
      ],
      userData: {
        label_printer_id: '',
        label_format: '',
        document_printer_id: '',
        language: '',
        date_format: '',
        time_format: '',
        timezone: '',
        return_waybill_action_type: '',
        goods_type_id: '',
        sender_id: '',
        receiver_id: '',
        document_package_id: '',
        parcel_package_id: '',
        pallet_package_id: '',
        stackable: '',
        auto_pallet_exchange: '',
        load_package_id: '',
        weight_type: '',
        dimension_type: '',
        shipper_reference: '',
        receiver_reference: '',
        receiver_email: '',
        description: '',
        should_show_freight_prices: false,
        currency: '',
        is_custom_currency: false,
        lock_receiver: false,
        lock_sender: false,
        show_has_temperature: false,
        show_dangerous_goods: false,
        show_freight_paid_by: false,
        show_incoterms: false,
        allowed_goods_types: [],
        book_permission_type: '',
        is_api_autoprint: '0',
        receiver_country_id: '',
        is_user_vat: false,
        vat_user_percent: ''
      },
      shippers: [],
      receiverLocations: [],
    };
  },
  computed: {
    ...mapGetters([
      'get_label_printers',
      'get_document_printers',
      'get_label_formats',
      'get_location_shippers',
      'get_document_packages_available',
      'get_parcel_packages_available',
      'get_pallet_packages_available',
      'get_load_packages_available',
      'get_goods_types',
      'get_user',
      'get_stored_user',
      'get_return_waybill_action_types',
      'get_subaccounts',
      'get_is_admin',
      'get_user_available_currencies',
      'get_user_currency_by_value'
    ]),
    timezones() {
      const tz = []
      let timezones = []
      if (this.get_user.language) {
        if (this.get_user.language === 'dk') {
          timezones = dkTimezone
        } else {
          timezones = enTimezone
        }
        for (let key in timezones) {
          tz.push({'value' : key, text : timezones[key]})
        }
      }
      return tz
    },
    isPopupSubmitDisabled() {
      const formWithValidators = [
        {
          formFeild:'email',
          value: this.form.email,
          validators:{required: true, email: true}
        },
        {
          formFeild:'first_name',
          value: this.form.first_name,
          validators:{required: true}
        },
        {
          formFeild:'last_name',
          value: this.form.last_name,
          validators:{required: true}
        },
      ]
      return this.validateInput(formWithValidators);
    },
    percentageOptions() {
      const options = [];
      for (let i = 15; i <= 30; i++) {
        options.push({
          value: i,
          text: `${i}%`,
        });
      }
      return options;
    },
    getAllowedSubaccounts() {
      return this.get_subaccounts.filter((acc) => this.get_user.accessible_subaccounts_array.indexOf(String(acc.id)) > -1).map((acc) => ({text: acc.name, value: String(acc.id),}));
    },
    subacountsList() {
      return this.get_subaccounts.map((acc) => ({text: acc.name, value: acc.id,}));
    },
    nameAndBackOption() {
      return this.$route.params.id != undefined ? true : false;
    },
    isEditableProfile() {
      //If user is super admin only owner or system user can change user data
      if ((this.get_user.id != this.get_stored_user.id) && this.get_stored_user.is_super_admin && !this.get_user.is_system_user) {
        return false;
      }

      if( this.get_is_admin || (this.$route.params.id === undefined)) {
        return true;
      } else if( this.$route.params.id == this.get_user.id ) {
        return true;
      } else {
        return false;
      }
    },
    allowedGoodsType() {
      return [
        {value: '1', text: this.$t('Parcel')},
        {value: '2', text: this.$t('Document')},
        {value: '3', text: this.$t('Pallet')},
        {value: '4', text: this.$t('Load')},
      ]
    },
    bookPermissionType() {
      return [
        {value: 1, text: this.$t('Can Book')},
        {value: 2, text: this.$t('Need approval')},
        {value: 3, text: this.$t('Remove button')},
      ]
    },
  },
  created() {
    // fetch all options for select boxes
    this.$store.dispatch('GET_OPTIONS_FOR_SELECTS_PREFERENCES').then(() => {

      this.$store.dispatch("GET_SHIPPERS", { type: [1, 2, 3, 4] }).then((res) => {
        const toOption = (opt) => ({
          value: opt.id,
          text: `
            ${opt.company_name ? opt.company_name + ', ' : ''}
            ${opt.name ? opt.name + ', ' : ''}
            ${opt.address_1 ? opt.address_1 + ', ' : ''}
            ${opt.post_code ? opt.post_code + ', ' : ''}
            ${opt.city ? opt.city + ', ' : ''}
            ${opt.state ? opt.state + ', ' : ''}
            ${opt.country_id ? this.getCountry(opt.country_id, 'name') : ''}
          `
        });
        const hasType = (opt, wanted) => {
          const t = Array.isArray(opt.type) ? opt.type : (opt.type ? JSON.parse(opt.type) : []);
          return wanted.some((x) => t.indexOf(String(x)) !== -1 || t.indexOf(x) !== -1);
        };
        const other = { value: null, text: 'Other address' };
        this.shippers = [other, ...res.filter((o) => hasType(o, [1, 2, 3])).map(toOption)];
        this.receiverLocations = [other, ...res.filter((o) => hasType(o, [4])).map(toOption)];
      }).then(() => {
        // populate default data from user profile
        this.userId = this.$route.params.id ? this.$route.params.id : localStorage.userId
        this.$store.dispatch('GET_USER', {id: this.userId}).then((res) => {
          this.userData.document_printer_id = res.document_printer_id || '0';
          this.userData.label_printer_id = res.label_printer_id || '0';
          this.userData.label_format = res.label_format;
          this.userData.language = res.language;
          this.userData.time_format = res.time_format;
          this.userData.date_format = res.date_format;
          this.userData.timezone = res.timezone;
          this.userData.time_format = res.time_format;
          this.userData.date_format = res.date_format;
          this.userData.timezone = res.timezone;
          this.userData.return_waybill_action_type = res.return_waybill_action_type;
          this.userData.goods_type_id = res.goods_type_id;
          this.userData.sender_id = res.sender_id;
          this.userData.receiver_id = res.receiver_id;
          this.userData.parcel_package_id = res.parcel_package_id || '0';
          this.userData.weight_type = res.weight_type;
          this.userData.dimension_type = res.dimension_type;
          this.userData.shipper_reference = res.shipper_reference;
          this.userData.receiver_reference = res.receiver_reference;
          this.userData.receiver_email = res.receiver_email
          this.userData.description = res.description
          this.userData.should_show_freight_prices = res.should_show_freight_prices;
          this.userData.currency = res.currency;
          this.userData.is_custom_currency = res.is_custom_currency;
          this.userData.show_has_temperature = res.show_has_temperature;
          this.userData.lock_receiver = res.lock_receiver;
          this.userData.lock_sender = res.lock_sender;
          this.userData.show_dangerous_goods = res.show_dangerous_goods;
          this.userData.show_freight_paid_by = res.show_freight_paid_by;
          this.userData.show_incoterms = res.show_incoterms;
          this.userData.allowed_goods_types = res.allowed_goods_types_array;
          this.userData.book_permission_type = res.book_permission_type;
          this.userData.is_api_autoprint = res.is_api_autoprint;
          this.userData.receiver_country_id = res.receiver_country_id;
          this.userData.is_user_vat = res.is_user_vat;
          this.userData.vat_user_percent = res.vat_user_percent;
          this.userData.document_package_id = this.get_stored_user.document_package_id;
          this.userData.parcel_package_id = this.get_stored_user.parcel_package_id;
          this.userData.pallet_package_id = this.get_stored_user.pallet_package_id;
          this.userData.stackable = this.get_stored_user.stackable;
          this.userData.auto_pallet_exchange = this.get_stored_user.auto_pallet_exchange;
          this.userData.load_package_id = this.get_stored_user.load_package_id;

          this.$nextTick(() => {
            this.loadUser = true;
            this.loadPreferences = true;
          });
        })
      });
    });
  },
  methods: {
    onCurrencyChange(val) {
      const currency = this.get_user_currency_by_value(val)
      this.userData.is_custom_currency = currency.is_custom;
    },
    removeSignature() {
      this.$store.dispatch('REMOVE_USER_SIGNATURE', {
        id: this.get_stored_user.id,
      }).then(() => {
        this.$refs.signatureUploadInput.remove();
        this.$store.dispatch('GET_USER', {id: this.get_stored_user.id});
      });
    },
    uploadSignature() {
      this.$refs.signatureUploadInput.click();
    },
    signatureSelected() {
      this.$store.dispatch('UPLOAD_USER_IMAGE', {
        id: this.get_stored_user.id,
        file: this.$refs.signatureUploadInput.files[0],
        type: 'signature'
      }).then(() => {
        this.$refs.signatureUploadInput.remove();
        this.$store.dispatch('GET_USER', {id: this.get_stored_user.id});
      });
    },
    showNotification(val) {
      //this.$store.commit('SHOW_ERROR', `Select promenjen: ${val}`)
    },
    selectAccessibleForSubaccounts(val) {
        this.form.accessible_for_subaccounts = val;
    },
    selectSubaccounts(val) {
        this.form.accessible_subaccounts = val;
    },
    selectAllowedGoodsType(val) {
        this.userData.allowed_goods_types = val;
    },
    selectBookPermissionType(val) {
        this.userData.book_permission_type = val;
    },
    cancelPreferenceSave() {
      this.showSavebar = false;
    },
    savePreferenceData() {
      this.$store.dispatch(`EDIT_USER`, {
        form: this.userData,
        id: this.userId,
      }).then(() => {
        if(this.$route.params.id == undefined || this.$route.params.id == this.get_user.id){
          this.$store.dispatch('GET_PROFILE').then((profileRes) => {
            this.$store.dispatch('STORE_USER', profileRes);
            this.showSavebar = false;
          })
        } else {
          //(old request object {id: this.get_user.id}, this is id of logged user, but here we need id from team member (from route)
          this.$store.dispatch('GET_USER', {id: this.$route.params.id }).then((res) => {
            this.showSavebar = false;
            this.$store.dispatch('STORE_LANGUAGE', res.language);
          });
        }
      });
    },
    routeIt() {
      this.$router.push('/settings/platform/team');
    },
    togglePopup() {
      this.openPopup = !this.openPopup;
    },
    saveProfileData() {
      let subaccountId = '';
      if(this.form.accessible_subaccounts.indexOf(String(this.form.active_subaccount_id)) > -1){
        subaccountId = String(this.form.active_subaccount_id);
      } else {
        subaccountId = String(this.form.accessible_subaccounts[0]);
        this.$store.dispatch(
          'STORE_ACTIVE_SUBACCOUNT',
          this.get_subaccounts.filter((subaccount) => subaccount.id == subaccountId)[0]
        );
      }

      this.$store.dispatch(`EDIT_USER`, {
        form: { ...this.form, phone: this.form.phone.number, active_subaccount_id: subaccountId},
        id: this.get_stored_user.id,
      }).then(() => {
        this.openPopup = false;
        this.$store.dispatch('GET_USER', {id: this.get_stored_user.id});
        this.$store.dispatch('GET_PROFILE').then((profileRes) => {
          this.$store.dispatch('STORE_USER', profileRes);
        });
      });
    },
    openEditPopup() {
      this.togglePopup()
      this.form = {
        is_admin: this.get_stored_user.is_admin,
        is_active: this.get_stored_user.is_active,
        active_subaccount_id: this.get_stored_user.active_subaccount_id,
        language: this.get_stored_user.language,
        email: this.get_stored_user.email,
        first_name: this.get_stored_user.first_name,
        last_name: this.get_stored_user.last_name,
        function: this.get_stored_user.function,
        return_waybill_action_type: this.get_stored_user.return_waybill_action_type,
        label_printer_id: this.get_stored_user.label_printer_id,
        label_format: this.get_stored_user.label_format,
        goods_type_id: this.get_stored_user.goods_type_id,
        document_package_id: this.get_stored_user.document_package_id,
        parcel_package_id: this.get_stored_user.parcel_package_id,
        pallet_package_id: this.get_stored_user.pallet_package_id,
        load_package_id: this.get_stored_user.load_package_id,
        weight_type: this.get_stored_user.weight_type,
        dimension_type: this.get_stored_user.dimension_type,
        should_show_freight_prices: this.get_stored_user.should_show_freight_prices,
        currency: this.get_stored_user.currency,
        phone: {
          number: this.get_stored_user.phone,
          country: '',
        },
        accessible_subaccounts: this.get_stored_user.accessible_subaccounts_array,
        accessible_for_subaccounts: this.get_stored_user.accessible_for_subaccounts
      }
    },
    resetPassword() {
      this.$store.dispatch('FORGOT_PASSWORD', {email: this.get_stored_user.email}).then(() => {
        this.openPopup = false;
        this.$store.commit('SHOW_NOTIFICATION_BAR', {
          message: this.$t('reset_password_notification_msg'),
          type: 'success-window',
        });
      });
    },
    deleteUserAction() {
      this.$store.dispatch('DELETE_USER', this.get_stored_user.id).then(() => {
        this.openPopup = false;
        this.$router.push('/settings/platform/team')
      });
    },
  },
  watch: {
    userData: {
      handler(){
        if(this.loadPreferences && this.loadUser){
          this.showSavebar = true;
        };
      },
      deep: true,
    },
  },
};
</script>
